import { PanelLeftOpen } from 'lucide-react';

interface TextWithHoverActionProps {
  value: string;
  isHovered: boolean;
  isEnabled?: boolean;
  onCellClick: () => void;
  onActionClick: () => void;
  actionLabel: string;
}

export function TextWithHoverAction({
  value,
  isHovered,
  isEnabled = true,
  onCellClick,
  onActionClick,
  actionLabel,
}: TextWithHoverActionProps) {
  return (
    <td
      className="size-px px-4 py-1 relative group cursor-pointer pe-20 lg:pe-24"
      onClick={onCellClick}
    >
      <div className="relative w-full">
        <span className="text-sm font-medium text-onsurface block whitespace-nowrap">
          {value}
        </span>
        <div
          className={`absolute top-0 end-0 h-full flex items-center ${
            isHovered && isEnabled ? 'opacity-100' : 'opacity-0'
          } transition-opacity duration-200`}
        >
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onActionClick();
            }}
            className="py-1.5 px-2 inline-flex items-center gap-x-1.5 text-xs font-medium rounded-lg border border-border bg-surface text-onsurface shadow-2xs hover:bg-surface-darker disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-surface-darker"
          >
            <PanelLeftOpen className="shrink-0 size-3.5 hidden lg:block" />
            {actionLabel}
          </button>
        </div>
      </div>
    </td>
  );
}
